<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-11 11:16:48
 * @LastEditors: Betway huangbo@mrcdevlab.com
 * @LastEditTime: 2025-04-01 15:59:59
-->
<template>
  <!-- 添加汇率弹窗 -->
  <v-dialog :value="isopen"
            @click:outside="()=>{
              if(!loading) cancel()
            }"
            :persistent="loading"
            :width="width"
            :style="{height:'80vh'}"
            @keydown="keydown"
            scrollable>
    <v-card>
      <v-card-subtitle class="is_flex_between"
                       v-if="!hiddenTitle"
                       style="background: #000000;
                              color: #ffffff;
                              padding-top: 10px;
                              padding-bottom: 10px">
        <span>{{ title ? title : $t('label_The_title') }}</span>
        <span @click="()=>{
              if(loading) return ;
              cancel()
            }"
              class="material-icons"
              :style="{
                cursor: loading?'not-allowed':'pointer'
              }"
              style="font-size: 20px">clear</span>
      </v-card-subtitle>
      <template v-if="noPadding">
        <v-card-text ref="dialogContent"
                     :class="cardTextPadding">
          <!-- 插入内容 -->
          <slot></slot>
        </v-card-text>
      </template>
      <template v-else>
        <div ref="dialogContent">
          <slot></slot>
        </div>
      </template>
      <mrc_ess_submitBtn @cancel="cancel"
                         v-if="disabled"
                         :loading="loading"
                         :successText="successText"
                         style="height: auto;padding: 24px 0"
                         :cancelText="cancelText"
                         @success="success"></mrc_ess_submitBtn>
    </v-card>
  </v-dialog>
</template>

<script>
/**
 * @params isopen 控制弹窗开关
 * @params width 弹窗宽度
 * @params title 弹窗标题
 * @params disabled 是否隐藏按钮
 * @event cancel 取消
 * @event success 成功
 */
export default {
  components: {},
  props: {
    persistent: {
      type: Boolean,
      default: false,
    },
    cardTextPadding: {
      type: String,
      default: 'pa-8'
    },
    isopen: {
      type: Boolean,
      default: false,
    },
    height: {
      type: [Number, String],
    },
    width: {
      type: [Number, String],
      default: 500,
    },
    title: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: true,
    },
    hiddenTitle: {
      type: Boolean,
      default: false,
    },
    successText: {
      type: String,
    },
    cancelText: {
      type: String,
    },
    noPadding: {
      type: Boolean,
      default: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  model: {
    prop: 'isopen',
    event: 'flag',
  },
  data () {
    return {}
  },
  created () { },
  mounted () { },
  methods: {
    keydown (v) {
      // if (v.keyCode == 27) {
      //   window.event.cancelBubble = true;
      //   window.event.returnValue = false;
      // }
    },
    success () {
      this.$refs.dialogContent.scrollTop = 0
      this.$emit('success')
    },
    cancel () {
      this.$refs.dialogContent.scrollTop = 0
      this.$emit('flag', !this.isopen)
      this.$emit('cancel', !this.isopen)
    },
  },
  computed: {},
  watch: {},
  beforeDestroy () { },
}
</script>

<style scoped></style>
